import React from "react";
import {useTranslation} from "react-i18next";

import networkData from "../NetworkButton/networkData.json";
import NetworkButton from "../NetworkButton";
import Title from "../TitleTemplate";

import "./style.scss"
import Image from "../Image";

const FollowUsFooter = () => {
    const {t} = useTranslation()

    return (
        <div className="footer_follow-us">
            <div className="footer_follow-us_block">
                <Title underline={true}><span>{t("footerFollowUsTitlePartOne")} </span>{t("footerFollowUsTitlePartTwo")}
                </Title>
                <div className="footer_follow-us_block_socials">
                    {networkData.map((elm) =>
                        <NetworkButton
                            size="lg"
                            link={elm.link}
                            key={elm.network}
                            icon={elm.network}
                            description={elm.description}
                        />
                    )}
                </div>
                <Image alt="M" src="/images/ESRB_M.png"/>
            </div>
        </div>
    )
}

export default FollowUsFooter